document.addEventListener("DOMContentLoaded", function () {
  const cartPage = document.getElementById("cartPage");

  if (cartPage) {
    // Delegación de eventos para botones de cantidad y eliminar
    cartPage.addEventListener("click", function (e) {
      const target = e.target;
      const action = target.getAttribute("data-action");
      const item = target.closest(".cart-item");
      const itemId = item ? item.getAttribute("data-item-id") : null;

      if (action === "increase" || action === "decrease") {
        updateQuantity(itemId, action);
      } else if (action === "remove") {
        removeItem(itemId);
      }
    });

    // Actualizar cantidad
    function updateQuantity(itemId, action) {
      const quantityInput = document.querySelector(
        `.cart-item[data-item-id="${itemId}"] .cart-item__quantity-input`
      );
      let quantity = parseInt(quantityInput.value);

      if (action === "increase") {
        quantity += 1;
      } else if (action === "decrease" && quantity > 1) {
        quantity -= 1;
      }

      fetch("/cart/change.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          id: itemId,
          quantity: quantity,
        }),
      })
        .then((response) => response.json())
        .then(() => {
          window.location.reload(); // Recargar para actualizar el carrito
        })
        .catch((error) => console.error("Error:", error));
    }

    // Eliminar producto
    function removeItem(itemId) {
      fetch("/cart/change.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          id: itemId,
          quantity: 0,
        }),
      })
        .then((response) => response.json())
        .then(() => {
          window.location.reload(); // Recargar para actualizar el carrito
        })
        .catch((error) => console.error("Error:", error));
    }
  }
});
